/**
 * L2-R5: moved to @miq/utils (lib/misc/clean-object.ts). This shim keeps the old
 * import path working; new code should import from '@miq/utils'.
 */
export { valuePresence, isObject, cleanObject, cleanObject2 } from '@miq/utils';
